
const Link = (props) => {
  const text = props.text || props.children
  const className = `link ${props.className || ''}`
  return <span {...props} className={className}>{text}</span>
}

export default Link
